module.exports = __webpack_public_path__ + "img/MEDIA040.cb01526f.jpg";